import axios from 'axios';
import { REACT_APP_API_BASE_URL } from '../url';
// Single axios client. Base URL from env (parent injects per environment).
const axiosClient = axios.create({
  baseURL: REACT_APP_API_BASE_URL || '/api',
});

// JWT interceptor: parent owns login and stores the token in localStorage.
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Unwrap the ApiResponse envelope; surface server message on failure.
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    const message = data?.message || error.message || 'Request failed';
    return Promise.reject({ ...error, friendlyMessage: message, errors: data?.errors });
  }
);

export default axiosClient;
